import PropTypes from 'prop-types';

import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';

import Indent from './Indent';


function NegativeMobile(props) {
  const {
    children,
    isMobile,
    theme,
  } = props;

  if (isMobile) {
    const { indents } = theme.layout;

    return (
      <Indent left={-indents.left} right={-indents.right}>
        {children}
      </Indent>
    );
  }

  return children;
}

NegativeMobile.propTypes = {
  /** @ignore */
  isMobile: PropTypes.bool,
  /** @ignore */
  theme: themePropTypes(`{
    layout: {
      indents: {
        left, right,
      }
    }
  }`),
};

const NegativeMobileWithHOCs = withTheme(withBreakpoint(NegativeMobile));
NegativeMobileWithHOCs.displayName = 'NegativeMobile';

export default NegativeMobileWithHOCs;
